// Пункты бокового меню. Вынесены из AppShell.tsx, потому что файл компонента
// не должен экспортировать константы (ломает Fast Refresh) — а список нужен и
// компоненту, и тестам.
import { isNative } from '../lib/platform'
import type { TablerIcon } from '@tabler/icons-react'

export interface NavChild {
  to: string
  label: string
  Icon: TablerIcon
}

export interface NavItem {
  to?: string
  label?: string
  icon?: string
  end?: boolean
  chatBadge?: boolean
  chatwoot?: boolean
  badge?: string
  divider?: boolean
  utility?: boolean
  Icon?: TablerIcon
  children?: NavChild[]
}

export const NAV: NavItem[] = [
  { to: '/', label: 'Чат', icon: 'icon-chat.svg', end: true, chatBadge: true },
  { to: '/practices', label: 'Практики', icon: 'icon-practices.svg' },
  { to: '/psychologist', label: 'Психолог', icon: 'icon-psychologist.svg' },
  { to: '/pricing', label: 'Тарифы', icon: 'icon-pricing.svg' },
  { to: '/faq', label: 'О сервисе', icon: 'icon-help.svg' },
  { divider: true },
  // Раздел «Приложение» — инструкция, как поставить PWA из браузера. Внутри
  // установленного приложения он ведёт в никуда, поэтому на нативе его нет.
  ...(isNative ? [] : [{ to: '/install', label: 'Приложение', utility: true }]),
  { to: '/settings', label: 'Настройки', utility: true },
  { to: '/support', label: 'Поддержка', utility: true, chatwoot: true },
]
